import React, { useState } from "react";
import { NotebookPen } from "lucide-react";
import { Breadcrumb } from "../components/Breadcrumb";
import { useAuth } from "../lib/auth";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { RekapAktivitas } from "../components/RekapAktivitas";
import { CatatanPribadi } from "../components/CatatanPribadi";

export default function PastoralAktivitasPage() {
  const { user } = useAuth();
  const isCL = user.role === "CARE_LEADER";
  const [tab, setTab] = useState("rekap");
  return (
    <div className="space-y-5" data-testid="pastoral-aktivitas-page">
      <div>
        <Breadcrumb items={[{ label: "Pastoral Care" }, { label: "Rekap & Catatan" }]} />
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 flex items-center gap-2"><NotebookPen className="h-7 w-7 text-[hsl(24,94%,45%)]" /> Rekap Aktivitas & Catatan Pribadi</h1>
        <p className="text-sm text-slate-500">{isCL ? "Catat setiap kontak dengan anggota binaan dan simpan catatan pribadi Anda." : "Rekap aktivitas Care Leader dalam menghubungi anggota binaannya."}</p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className={`w-full grid ${isCL ? "grid-cols-2" : "grid-cols-1"} h-auto rounded-xl bg-slate-100 p-1 max-w-md`}>
          <TabsTrigger value="rekap" className="rounded-lg min-h-[40px]" data-testid="tab-rekap-aktivitas">Rekap Aktivitas</TabsTrigger>
          {isCL && <TabsTrigger value="catatan" className="rounded-lg min-h-[40px]" data-testid="tab-catatan-pribadi">Catatan Pribadi</TabsTrigger>}
        </TabsList>
        <TabsContent value="rekap" className="mt-4"><RekapAktivitas /></TabsContent>
        {isCL && <TabsContent value="catatan" className="mt-4"><CatatanPribadi /></TabsContent>}
      </Tabs>
    </div>
  );
}
